export default __webpack_public_path__ + "static/omnibar-concept-dark-dc40dd0fd90ee66c1f7e5c7f6872cf30.mp4";